import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Fragment, memo } from 'react';
import cc from 'classcat';
import PropTypes from 'prop-types';
import css from './UGC.module.scss';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

var Handles = function Handles(_ref) {
  var handles = _ref.handles,
      total = _ref.total;
  var props = {
    rel: 'noreferrer',
    target: '_blank'
  };
  var style = {
    '--delay': "".concat(total * 0.1 + 0.1, "s")
  };

  if (handles.length === 1) {
    var handl = handles[0];
    return /*#__PURE__*/_jsx("div", {
      className: css.handlesWrap,
      children: /*#__PURE__*/_jsxs("a", _objectSpread(_objectSpread({}, props), {}, {
        className: cc([css.handles, css.link]),
        href: "https://instagram.com/".concat(handl),
        style: style,
        children: ["@", handl]
      }))
    });
  }

  return /*#__PURE__*/_jsx("div", {
    className: css.handlesWrap,
    children: /*#__PURE__*/_jsx("div", {
      className: css.handles,
      role: "button",
      tabIndex: 0,
      style: style,
      children: handles.map(function (handle, idx) {
        return /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsxs("a", _objectSpread(_objectSpread({}, props), {}, {
            href: "https://instagram.com/".concat(handle),
            children: ["@", handle]
          })), idx !== handles.length && /*#__PURE__*/_jsx("span", {
            children: ", "
          })]
        }, handle);
      })
    })
  });
};

Handles.propTypes = {
  handles: PropTypes.arrayOf(PropTypes.string).isRequired,
  total: PropTypes.number.isRequired
};
export default /*#__PURE__*/memo(Handles);